import DatabaseModel from './DatabaseModelOffline.js';

var Inspector = Object.create(DatabaseModel);

Inspector.model = 'inspectores';

export default Inspector;